<template>
  <div class="workOrderConfirm">
    <div
      style="width: 125.5px; height: 127px; margin: 0 auto; margin-bottom: 4px"
    >
      <img
        style="width: 100%; height: 100%"
        src="@/assets/img/official-account/Group 54.png"
        alt=""
      />
    </div>
    <div class="workOrderConfirm__title">工单提交成功</div>
    <div class="workOrderConfirm__order-no" v-if="$route.query.id">
      <span class="workOrderConfirm__order-no__label">工单编号：</span>
      <span class="workOrderConfirm__order-no__value">{{
        $route.query.id
      }}</span>
      <button
        class="workOrderConfirm__order-no__copy"
        type="button"
        @click="copyOrderNo"
      >
        <svg
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
        >
          <rect
            x="5.5"
            y="2.5"
            width="8"
            height="10"
            rx="1.2"
            stroke="#60bb46"
            stroke-width="1.2"
          />
          <path
            d="M2.5 5.5v7.2c0 .44.36.8.8.8h7.2"
            stroke="#60bb46"
            stroke-width="1.2"
            stroke-linecap="round"
          />
        </svg>
        <span>复制</span>
      </button>
    </div>
    <div class="workOrderConfirm__size">
      工作人员会在1~2个工作日内与您联系，请保持手机畅通
    </div>
    <div class="workOrderConfirm__but" @click="goBack">返回首页</div>
    <div class="workOrderConfirm__notice">
      <div class="workOrderConfirm__notice__header">注意事项</div>
      <div
        class="workOrderConfirm__notice__card workOrderConfirm__notice__card--green"
      >
        <div class="workOrderConfirm__notice__card__dot"></div>
        <div class="workOrderConfirm__notice__card__content">
          <div class="workOrderConfirm__notice__card__label">质保期内</div>
          <div class="workOrderConfirm__notice__card__desc">
            优先免费检修，售后服务人员1-2个工作日尽快与您联系；
          </div>
        </div>
      </div>
      <div
        class="workOrderConfirm__notice__card workOrderConfirm__notice__card--orange"
      >
        <div class="workOrderConfirm__notice__card__dot"></div>
        <div class="workOrderConfirm__notice__card__content">
          <div class="workOrderConfirm__notice__card__label">超出质保</div>
          <div class="workOrderConfirm__notice__card__desc">
            可能产生人工/配件等相应费用；
          </div>
        </div>
      </div>
      <div
        class="workOrderConfirm__notice__card workOrderConfirm__notice__card--blue"
      >
        <div class="workOrderConfirm__notice__card__dot"></div>
        <div class="workOrderConfirm__notice__card__content">
          <div class="workOrderConfirm__notice__card__label">暂无法判断</div>
          <div class="workOrderConfirm__notice__card__desc">
            售后服务人员1-2个工作日内主动联系确认并安排后续服务。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {};
  },
  created() {
    console.log(this.$route.query);
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.push({ path: "/appraise" });
    },
    async copyOrderNo() {
      const id = this.$route.query.id;
      if (!id) return;
      const text = String(id);
      let ok = false;
      // 优先使用新 Clipboard API（HTTPS 且支持的环境）
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
          ok = true;
        }
      } catch (e) {
        ok = false;
      }
      // 降级：execCommand（兼容微信 WebView/老 iOS Safari）
      if (!ok) {
        try {
          const input = document.createElement("textarea");
          input.value = text;
          input.style.position = "fixed";
          input.style.top = "-9999px";
          input.style.opacity = "0";
          input.setAttribute("readonly", "readonly");
          document.body.appendChild(input);
          input.select();
          input.setSelectionRange(0, text.length);
          ok = document.execCommand("copy");
          document.body.removeChild(input);
        } catch (e) {
          ok = false;
        }
      }
      if (ok) {
        Toast.success("工单编号已复制");
      } else {
        Toast.fail("复制失败，请手动截图保存");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.workOrderConfirm {
  background-color: #fff;
  height: 100vh;
  padding: 12px;
  padding-top: 8px;
  &__title {
    color: #181818;
    text-align: center;
  }
  &__order-no {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
    color: #60bb46;
    font-size: 13px;
    text-align: center;
    margin-top: 6px;
    font-weight: 500;
    &__label {
      color: #60bb46;
    }
    &__value {
      color: #60bb46;
      font-weight: 600;
      letter-spacing: 0.3px;
    }
    &__copy {
      display: inline-flex;
      align-items: center;
      gap: 3px;
      margin-left: 6px;
      padding: 3px 10px;
      height: 22px;
      background: #f0fae6;
      border: 1px solid rgba(96, 187, 70, 0.4);
      border-radius: 11px;
      color: #60bb46;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      transition: background 0.15s ease;
      -webkit-tap-highlight-color: transparent;
      &:active {
        background: #d9f0c4;
      }
    }
  }
  &__size {
    color: #909090;
    font-size: 13px;
    width: 210px;
    text-align: center;
    margin: 0 auto;
    margin-top: 8px;
  }
  &__but {
    width: 252px;
    height: 42px;
    background: #60bb46;
    border-radius: 400px;
    color: #fff;
    text-align: center;
    line-height: 42px;
    margin: 0 auto;
    margin-top: 28px;
    font-size: 15px;
  }
  &__notice {
    margin: 28px 4px 0;
    &__header {
      font-size: 13px;
      font-weight: 600;
      color: #60bb46;
      margin-bottom: 12px;
    }
    &__card {
      display: flex;
      align-items: flex-start;
      padding: 12px 14px;
      border-radius: 10px;
      margin-bottom: 8px;
      &__dot {
        width: 8px;
        height: 8px;
        min-width: 8px;
        border-radius: 50%;
        margin-top: 5px;
        margin-right: 10px;
      }
      &__content {
        flex: 1;
      }
      &__label {
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 3px;
      }
      &__desc {
        font-size: 12px;
        line-height: 1.6;
        opacity: 0.85;
      }
      &--green {
        background: rgba(96, 187, 70, 0.08);
        .workOrderConfirm__notice__card__dot {
          background: #60bb46;
        }
        .workOrderConfirm__notice__card__label {
          color: #60bb46;
        }
        .workOrderConfirm__notice__card__desc {
          color: #5a9e42;
        }
      }
      &--orange {
        background: rgba(96, 187, 70, 0.06);
        .workOrderConfirm__notice__card__dot {
          background: #60bb46;
        }
        .workOrderConfirm__notice__card__label {
          color: #60bb46;
        }
        .workOrderConfirm__notice__card__desc {
          color: #5a9e42;
        }
      }
      &--blue {
        background: rgba(96, 187, 70, 0.06);
        .workOrderConfirm__notice__card__dot {
          background: #60bb46;
        }
        .workOrderConfirm__notice__card__label {
          color: #60bb46;
        }
        .workOrderConfirm__notice__card__desc {
          color: #5a9e42;
        }
      }
    }
  }
}
</style>
